import { useContext } from "react";
import { AuthContext } from "../SessionChecker/SessionChecker";
import { useTranslation } from "react-i18next";
import "../../css/Home/Home.css";
import { useNavigate } from "react-router-dom";

function Home({ theme }) {
  const navigate = useNavigate(); 

  const {
    sessionStatus,
    currentUserUsername,

    blueTick,
    goldenTick,
    goldenTick2,
    gemTick,
  } = useContext(AuthContext);

  const { t } = useTranslation();

  return (
    <div className="mainDiv"> 
      <div className={`headerDiv ${theme}`}>
        {sessionStatus ? (
          <>
            <div>{currentUserUsername}</div>
            {blueTick && !goldenTick && !goldenTick2 && !gemTick ? (
              <div className="tickDiv">
                <img src="/icons/blue_tick.png"></img>
              </div>
            ) : !blueTick && goldenTick && !goldenTick2 && !gemTick ? (
              <div className="tickDiv">
                <img src="/icons/golden_tick.png"></img>
              </div>
            ) : !blueTick && !goldenTick && goldenTick2 && !gemTick ? (
              <div className="tickDiv golden2">
                <img src="/images/golden_tick2_512.png"></img>
              </div>
            ) : !blueTick && !goldenTick && !goldenTick2 && gemTick ? (
              <div className="tickDiv with24">
                <img src="/icons/gem_tick.png"></img>
              </div>
            ) : null}
          </>
        ) : (
          <button
            className="signinButton"
            onClick={() => {
              navigate("/signin");
            }}
          >
            {t("Signin")}
          </button>
        )}
      </div>

      <div className="contentDiv">
        {!sessionStatus && <div className="signinMessage">{t('Signin to view this section')}</div>}
      </div>
    </div>
  );
}

export default Home;
